(() => {
  const sections = document.querySelectorAll(".sas-who-we-are");
  if (!sections.length) return;

  sections.forEach((section) => {
    const frame = section.querySelector(".sas-who-we-are__media-frame");
    const button = section.querySelector(".sas-who-we-are__media-button");
    const video = section.querySelector("video");
    const iframe = section.querySelector("iframe[data-src]");
    const poster = section.querySelector(".sas-who-we-are__embed-poster");
    if (!button) return;

    const hideOverlay = () => {
      if (frame) {
        frame.classList.add("is-playing");
      }
    };

    const playVideo = () => {
      if (video) {
        video.play();
      }
      if (iframe) {
        iframe.setAttribute("src", iframe.dataset.src);
      }
      hideOverlay();
    };

    button.addEventListener("click", playVideo);
    if (video) {
      video.addEventListener("play", hideOverlay);
      video.addEventListener("ended", () => {
        if (frame) frame.classList.remove("is-playing");
      });
      video.addEventListener("pause", () => {
        if (frame) frame.classList.remove("is-playing");
      });
    }
  });
})();
